import { SnMapClusterPoint } from '@lib/api';
import { GoogleMapClusterMarker } from '@lib/geo/google/map';

export class SnAlarmClusterMarker extends GoogleMapClusterMarker {
  constructor(cluster: SnMapClusterPoint) {
    super(cluster, {
      icon: {
        fontIcon: 'Icon_GeneralAlert',
        fontSet: 'fs',
      },
    });
  }
}
